var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{ref:"tab",staticClass:"single-tab",on:{"click":function($event){return _vm.selectTab()}}},[_c('i',{class:_vm.icon}),_c('span',{staticClass:"navigation-name"},[(this.$parent.shouldExpand == true)?_vm._t("default"):_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }